export const common = {
  nav: {
    home: 'Ana Sayfa',
    projects: 'Projeler',
    furniture: 'Mobilya',
    news: 'Haberler',
    contact: 'İletişim',
    aiAssistant: 'AI Asistan',
    ar: 'AR Deneyimi',
    exterior: 'Dış Cephe',
    about: 'Hakkımızda'
  },
  hero: {
    title1: 'Doğanın Geometrisi',
    title2: 'Mimarlıkta Yeniden Doğuyor',
    description: 'Amorf formlar ve doğal malzemelerle özel mobilya tasarımı, iç mimari danışmanlık ve prefabrik yapı çözümleri',
    exploreProjects: 'Projeleri Keşfet',
    viewAR: 'AR ile Görüntüle',
    europeanStandards: 'Avrupa Standartları',
    globalDelivery: 'Global Teslimat',
    arTechnology: 'AR Teknolojisi',
    customDesign: 'Özel Tasarım'
  },
  projects: {
    title: 'Öne Çıkan Projeler',
    subtitle: 'Global standartlarda tamamlanmış mimari ve iç mekan projeleri',
    viewDetails: 'Detayları Görüntüle',
    istanbul: 'İstanbul, Türkiye',
    dubai: 'Dubai, BAE',
    london: 'Londra, İngiltere',
    paris: 'Paris, Fransa',
    berlin: 'Berlin, Almanya',
    miami: 'Miami, ABD',
    project1: 'Boğaz Manzaralı Lüks Rezidans',
    project2: 'Modern Ofis Kompleksi',
    project3: 'Minimalist Villa Tasarımı',
    project4: 'Sanat Galerisi İç Mekan',
    project5: 'Butik Otel Projesi',
    project6: 'Penthouse Daire'
  },
  ar: {
    title: 'Artırılmış Gerçeklik ile Mobilyalarınızı Görün',
    subtitle: 'Satın almadan önce mobilyaları kendi mekanınızda AR teknolojisi ile deneyimleyin',
    feature1Title: 'Gerçek Boyutta Görüntüleme',
    feature1Desc: 'Mobilyaları gerçek boyutlarında mekanınızda görün',
    feature2Title: 'Anında Karar Verin',
    feature2Desc: 'Ürünlerin mekanınıza uyumunu hemen test edin',
    feature3Title: 'Kolay Kullanım',
    feature3Desc: 'Telefonunuzla saniyeler içinde AR deneyimi yaşayın',
    tryNow: 'Şimdi Deneyin'
  },
  furniture: {
    title: 'Özel Mobilya Koleksiyonları',
    subtitle: 'Doğal malzemeler ve amorf formlarla tasarlanmış benzersiz parçalar',
    organicTables: 'Organik Masalar',
    organicTablesDesc: 'Doğal ahşap ve reçine kombinasyonu',
    sculptural: 'Heykelsi Oturma',
    sculpturalDesc: 'Sanat eseri niteliğinde koltuklar',
    lighting: 'Aydınlatma',
    lightingDesc: 'El yapımı tasarım lambalar',
    storage: 'Depolama',
    storageDesc: 'Fonksiyonel saklama çözümleri',
    viewCollection: 'Koleksiyonu İncele'
  },
  news: {
    title: 'Mimarlık ve Tasarım Haberleri',
    subtitle: 'Global mimarlık dünyasından güncel haberler ve trendler',
    readMore: 'Devamını Oku',
    news1Title: 'Sürdürülebilir Mimarlıkta Yeni Trendler',
    news1Desc: 'Çevre dostu malzemeler ve enerji verimliliği odaklı tasarımlar mimarlık dünyasını dönüştürüyor',
    news2Title: 'Biophilic Tasarım: Doğa ile İç İçe Yaşam',
    news2Desc: 'İç mekanlarda doğal elementlerin kullanımı sağlık ve refahı artırıyor',
    news3Title: 'Akıllı Ev Teknolojileri 2025',
    news3Desc: 'Yapay zeka destekli ev sistemleri konfor ve güvenliği yeni seviyeye taşıyor'
  },
  exterior: {
    title: 'Dış Cephe Kaplama',
    subtitle: 'Modern ve dayanıklı cephe çözümleri',
    description: 'Avrupa standartlarında, estetik ve fonksiyonel dış cephe kaplama sistemleri. Doğal taş, ahşap ve kompozit malzemelerle özel tasarım uygulamaları.',
    learnMore: 'Daha Fazla Bilgi',
    prefabTitle: 'Prefabrik Yapılar',
    prefabSubtitle: 'Hızlı ve kaliteli inşaat çözümleri',
    prefabDescription: 'Modüler ve prefabrik yapı sistemleri ile kısa sürede, yüksek kalitede projeler. Enerji verimliliği ve sürdürülebilirlik odaklı çözümler.'
  },
  testimonials: {
    title: 'Müşteri Görüşleri',
    subtitle: 'Global müşterilerimizin deneyimleri',
    client1: 'Ahmet Yılmaz',
    client1Title: 'Villa Sahibi, İstanbul',
    client1Text: 'Ernado ekibi, hayalimizdeki evi gerçeğe dönüştürdü. Doğal malzemeler ve özel tasarım mobilyalar harika. AR teknolojisi sayesinde satın almadan önce her şeyi görebildik.',
    client2: 'Ayşe Demir',
    client2Title: 'Otel Yöneticisi, Antalya',
    client2Text: 'Otelimizin iç mekan tasarımı için Ernado ile çalışmak mükemmel bir deneyimdi. Profesyonel yaklaşımları ve zamanında teslimat bizi çok memnun etti.',
    client3: 'Mehmet Kaya',
    client3Title: 'Mimar, Ankara',
    client3Text: 'Prefabrik yapı projemizde Ernado\'nun uzmanlığı ve kalitesi beklentilerimizi aştı. Avrupa standartlarında işçilik ve malzeme kalitesi.',
    client4: 'Zeynep Arslan',
    client4Title: 'İç Mimar, İzmir',
    client4Text: 'Özel mobilya tasarımlarında Ernado\'nun yaratıcılığı ve detaylara gösterdiği özen takdire şayan. Her parça bir sanat eseri gibi.',
    client5: 'Can Özdemir',
    client5Title: 'Restoran Sahibi, Bodrum',
    client5Text: 'Restoranımızın dış cephe kaplaması ve iç mekan tasarımı için Ernado ile çalıştık. Sonuç muhteşem, müşterilerimiz sürekli mekanı övüyor.',
    client6: 'Elif Şahin',
    client6Title: 'Ev Sahibi, Bursa',
    client6Text: 'Dairemizin yenilenmesinde Ernado\'nun danışmanlık hizmeti çok değerliydi. Amorf formlar ve doğal malzemeler mekanıma benzersiz bir karakter kattı.'
  },
  footer: {
    description: 'Doğal malzemeler ve amorf formlarla özel mobilya tasarımı, iç mimari danışmanlık ve prefabrik yapı çözümleri sunan global bir tasarım firması.',
    quickLinks: 'Hızlı Bağlantılar',
    services: 'Hizmetlerimiz',
    interiorDesign: 'İç Mimari Danışmanlık',
    customFurniture: 'Özel Mobilya Tasarımı',
    exteriorCladding: 'Dış Cephe Kaplama',
    prefabBuildings: 'Prefabrik Yapılar',
    contact: 'İletişim',
    newsletter: 'ERNADO',
    newsletterText: 'Yeni projeler ve haberlerden haberdar olun',
    emailPlaceholder: 'ernado@outlook.com.tr',
    subscribe: 'Abone Ol',
    rights: 'Tüm hakları saklıdır.',
    phone: 'Telefon',
    email: 'E-posta',
    address: 'Adres',
    addressText: 'Nilüfer, Bursa, Türkiye',
    privacy: 'Gizlilik Politikası',
    terms: 'Kullanım Koşulları'
  },
  privacy: {
    title: 'Gizlilik ve Kişisel Verilerin Korunması Politikası',
    intro: 'ERNADO ("Şirket") olarak, kişisel verilerinizin güvenliği hususuna azami hassasiyet göstermekteyiz. Bu bilinçle, ERNADO internet sitesi ve diğer tüm kanallar aracılığıyla elde edilen kişisel veriler; 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK")\'na uygun olarak işlenmekte, saklanmakta ve muhafaza edilmektedir.',
    section1Title: '1. Kişisel Verilerinizin İşlenme Şekli',
    section1Text: 'KVKK uyarınca, ERNADO ile paylaştığınız kişisel verileriniz; tamamen veya kısmen otomatik ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilebilir, kaydedilebilir, depolanabilir, güncellenebilir, değiştirilebilir, yeniden düzenlenebilir ve mevzuatın izin verdiği ölçüde işlenebilir. KVKK kapsamında veriler üzerinde gerçekleştirilen her türlü işlem "kişisel verilerin işlenmesi" olarak kabul edilmektedir.',
    section2Title: '2. Kişisel Verilerinizin İşlenme Amaçları ve Hukuki Sebepleri',
    section2Text: 'Toplanan kişisel verileriniz; Ürün ve hizmetlerimizin sunulabilmesi, geliştirilmesi ve iyileştirilmesi, Müşteri ilişkileri süreçlerinin yürütülmesi, Teklif, talep, sözleşme ve satış sonrası destek süreçlerinin yönetilmesi, Hukuki yükümlülüklerin yerine getirilmesi, Kamu güvenliği ve hukuki uyuşmazlıklarda yetkili mercilere bilgi verilmesi, Pazarlama, reklam ve analiz faaliyetlerinin yürütülmesi amaçlarıyla, KVKK\'nın 5. ve 6. maddelerinde belirtilen hukuki sebepler çerçevesinde işlenmektedir.',
    section3Title: '3. Kişisel Verilerin Aktarılabileceği Kişi ve Kuruluşlar',
    section3Text: 'Kişisel verileriniz; yukarıda belirtilen amaçlarla sınırlı olmak kaydıyla; İş ortaklarımıza, Tedarikçilerimize ve hizmet aldığımız üçüncü kişi firmalara, Yetkili kamu kurum ve kuruluşlarına, Hukuki yükümlülükler kapsamında mahkemeler ve icra dairelerine KVKK\'ya uygun olarak aktarılabilecektir.',
    section4Title: '4. Kişisel Verilerinizin Toplanma Yöntemi',
    section4Text: 'Kişisel verileriniz; ERNADO internet sitesi üzerindeki iletişim, teklif ve başvuru formları, Telefon, e-posta ve dijital iletişim kanalları, Sosyal medya platformları, Çerezler (cookies) ve benzeri teknolojiler aracılığıyla sözlü, yazılı veya elektronik ortamda toplanabilmektedir.',
    section5Title: '5. KVKK Yürürlüğe Girmeden Önce Elde Edilen Veriler',
    section5Text: 'ERNADO, KVKK\'nın yürürlük tarihi olan 7 Nisan 2016\'dan sonra faaliyetlerine başladığından, bu tarihten önce elde edilmiş ve saklanan herhangi bir kişisel veri bulunmamaktadır.',
    section6Title: '6. Kişisel Verilerin Yurt İçine ve Yurt Dışına Aktarılması',
    section6Text: 'Kişisel verileriniz; hizmetlerin yürütülmesi amacıyla, KVKK\'da belirtilen şartlara uygun olmak kaydıyla yurt içinde veya Kişisel Verileri Koruma Kurulu tarafından yeterli korumaya sahip olduğu belirlenen yurt dışındaki hizmet sağlayıcılara aktarılabilir.',
    section7Title: '7. Kişisel Verilerin Saklanması ve Korunması',
    section7Text: 'ERNADO, KVKK\'nın 12. maddesi uyarınca; Yetkisiz erişimi önlemek, Hukuka aykırı veri işlemeyi engellemek, Kişisel verilerin güvenliğini sağlamak amacıyla gerekli teknik ve idari tedbirleri almaktadır. Veri ihlali halinde durum derhal Kişisel Verileri Koruma Kurulu\'na bildirilecektir.',
    section8Title: '8. Kişisel Verilerin Güncel ve Doğru Tutulması',
    section8Text: 'Kişisel verilerin doğru ve güncel tutulması KVKK gereğidir. Bu nedenle kullanıcıların, bilgilerini doğru paylaşmaları ve gerekli hallerde güncellemeleri önem arz etmektedir.',
    section9Title: '9. KVKK Kapsamında Kişisel Veri Sahibinin Hakları',
    section9Text: 'KVKK\'nın 11. maddesi uyarınca veri sahipleri; Kişisel verilerinin işlenip işlenmediğini öğrenme, İşlenmişse buna ilişkin bilgi talep etme, İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme, Yurt içi veya yurt dışı aktarım yapılan üçüncü kişileri bilme, Eksik veya yanlış işlenen verilerin düzeltilmesini isteme, Kişisel verilerin silinmesini veya yok edilmesini isteme, Otomatik sistemler aracılığıyla analiz edilmesi sonucu aleyhine bir durum ortaya çıkmasına itiraz etme, Kanuna aykırı işlem sebebiyle zararın giderilmesini talep etme haklarına sahiptir.',
    section10Title: '10. İletişim ve Başvuru',
    section10Text: 'KVKK kapsamındaki taleplerinizi yazılı olarak veya elektronik ortamda aşağıdaki iletişim kanalları aracılığıyla bize iletebilirsiniz: E-posta: iletisim@ernado.com. Başvurular, KVKK\'ya uygun olarak en geç 30 gün içerisinde sonuçlandırılacaktır.',
    cookieTitle: 'ÇEREZ (COOKIE) POLİTİKASI',
    cookieText: 'ERNADO olarak, internet sitemizi ziyaret eden kullanıcılarımızın deneyimini geliştirmek amacıyla çerezlerden (cookies) faydalanmaktayız. Bu Çerez Politikası, kullanılan çerez türlerini ve kullanıcıların bu konudaki haklarını açıklamaktadır.',
    cookieSection1Title: '1. Çerez Nedir?',
    cookieSection1Text: 'Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcınız aracılığıyla cihazınıza kaydedilen küçük metin dosyalarıdır. Çerezler sayesinde site daha verimli çalışır ve kullanıcı tercihleri hatırlanır.',
    cookieSection2Title: '2. Kullanılan Çerez Türleri',
    cookieSection2Text: 'ERNADO internet sitesinde; Zorunlu Çerezler: Web sitesinin doğru şekilde çalışması için gereklidir. Performans ve Analitik Çerezleri: Site kullanımını analiz ederek hizmetlerimizi geliştirmemizi sağlar. Fonksiyonel Çerezler: Kullanıcı tercihlerini hatırlayarak kişiselleştirilmiş deneyim sunar. Reklam ve Pazarlama Çerezleri: İlgi alanlarınıza uygun içerik ve reklam sunulmasını sağlar.',
    cookieSection3Title: '3. Çerezlerin Yönetilmesi',
    cookieSection3Text: 'Tarayıcı ayarlarınız üzerinden çerezleri kabul edebilir, reddedebilir veya silebilirsiniz. Çerezlerin devre dışı bırakılması halinde web sitesinin bazı bölümleri düzgün çalışmayabilir.',
    kvkkTitle: 'KVKK AYDINLATMA METNİ',
    kvkkIntro: 'ERNADO olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında veri sorumlusu sıfatıyla, kişisel verilerinizi aşağıda açıklanan çerçevede işlemekteyiz.',
    kvkkDataTitle: 'İşlenen Kişisel Veriler',
    kvkkDataText: 'Ad, soyad, telefon numarası, e-posta adresi, IP bilgileri, talep ve mesaj içerikleri.',
    kvkkPurposeTitle: 'Kişisel Verilerin İşlenme Amaçları',
    kvkkPurposeText: 'İletişim faaliyetlerinin yürütülmesi, Teklif ve talep süreçlerinin yönetilmesi, Hizmet kalitesinin artırılması, Hukuki yükümlülüklerin yerine getirilmesi.',
    kvkkLegalTitle: 'Hukuki Sebep',
    kvkkLegalText: 'KVKK\'nın 5. maddesi uyarınca; sözleşmenin kurulması ve ifası, hukuki yükümlülüklerin yerine getirilmesi ve meşru menfaatler.',
    kvkkRightsTitle: 'Haklarınız',
    kvkkRightsText: 'KVKK\'nın 11. maddesi kapsamında tüm haklara sahipsiniz. Taleplerinizi iletisim@ernado.com adresi üzerinden iletebilirsiniz.',
    contact: 'Gizlilik politikamız hakkında sorularınız varsa, lütfen bizimle iletişime geçin: ernado@outlook.com.tr'
  },
  terms: {
    title: 'Kullanım Koşulları',
    intro: 'ERNADO web sitesini kullanarak, aşağıdaki kullanım koşullarını kabul etmiş olursunuz. Lütfen bu koşulları dikkatlice okuyun.',
    section1Title: 'Hizmet Kullanımı',
    section1Text: 'Web sitemiz ve içeriği yalnızca yasal amaçlar için kullanılabilir. Sitemizi kullanırken, yasalara, düzenlemelere ve üçüncü taraf haklarına saygı göstermeyi kabul edersiniz.',
    section2Title: 'Fikri Mülkiyet',
    section2Text: 'Web sitemizdeki tüm içerik, tasarımlar, logolar, görseller ve metinler ERNADO\'nun mülkiyetindedir ve telif hakkı yasalarıyla korunmaktadır. İzinsiz kullanım, kopyalama veya dağıtım yasaktır.',
    section3Title: 'Sorumluluk Reddi',
    section3Text: 'Web sitemizde yer alan bilgilerin doğruluğunu sağlamak için çaba göstermekteyiz, ancak bilgilerin eksiksiz veya güncel olduğunu garanti etmiyoruz. ERNADO, web sitesinin kullanımından kaynaklanan herhangi bir zarar veya kayıptan sorumlu tutulamaz.',
    section4Title: 'Bağlantılar',
    section4Text: 'Web sitemiz, üçüncü taraf web sitelerine bağlantılar içerebilir. Bu bağlantılar yalnızca kolaylık sağlamak amacıyla verilmiştir ve ERNADO, bu sitelerin içeriğinden veya gizlilik uygulamalarından sorumlu değildir.',
    section5Title: 'Değişiklikler',
    section5Text: 'ERNADO, bu kullanım koşullarını herhangi bir zamanda değiştirme hakkını saklı tutar. Değişiklikler web sitesinde yayınlandığı anda yürürlüğe girer.',
    section6Title: 'İletişim',
    section6Text: 'Kullanım koşulları hakkında sorularınız varsa, lütfen bizimle iletişime geçin: ernado@outlook.com.tr'
  }
};